import { ICompanyCreditInfo } from '../mst'

export class CompanyUtils {
  public static getCompanyName(company: any): string {
    const legalName = company?.legalName?.trim()
    const dba = company?.name?.trim()

    return legalName || dba || ''
  }

  public static getFullCompanyName(company: any): string {
    if (!company) return ''

    const legalName = company.legalName?.trim()
    const dba = company.name?.trim()

    if (legalName === dba) return legalName ?? ''
    if (legalName && dba) return `${dba} / ${legalName}`

    return legalName || dba || ''
  }

  public static getAvailableCreditAmount(
    creditInfo?: ICompanyCreditInfo,
    heldAmount?: number,
  ) {
    // this method is used in old BO, and will give wrong results for held amount
    // if for some reason it will be needed there, update admin loan application endpoint with draw approvalss
    if (!creditInfo) return 0

    const creditLimit = creditInfo.limit ?? 0
    const outstandingBalance = creditInfo.balance ?? 0

    const availableAmount = creditLimit - outstandingBalance - (heldAmount ?? 0)

    return Math.max(availableAmount, 0)
  }
}
